interface PeopleTableHeaderProps {
    /** Etiqueta de la columna del medio: lo que cambia entre una tabla y otra. */
    middle: string;
}

/**
 * Cabecera de las tablas de personas de una clase — participantes, personas de
 * prueba, lista de espera y la lista de asistencia.
 *
 * Vive aparte porque "Asistencia" tenía su propio maquetado y se leía como otra
 * pantalla dentro de la misma: son todas lo mismo, quién está en la sala, y la
 * rejilla 5/5/2 es lo que las hace mirarse igual. Duplicar las clases garantizaba
 * que se separaran otra vez a la primera columna nueva.
 *
 * `hidden lg:grid` porque en móvil las filas se apilan y una cabecera sobre
 * columnas que ya no existen estorba.
 */
const PeopleTableHeader = ({ middle }: PeopleTableHeaderProps) => (
    <div className='hidden lg:grid grid-cols-12 gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200 rounded-t-lg text-[11px] font-semibold uppercase tracking-wide text-gray-500'>
        <span className='col-span-5'>Nombre</span>
        <span className='col-span-5'>{middle}</span>
        <span className='col-span-2 text-right'>Acciones</span>
    </div>
);

export default PeopleTableHeader;
